import FormHelperText from "@mui/material/FormHelperText";
import { useTheme } from "@mui/material/styles";
import {
  DateValidationError,
  PickerChangeHandlerContext,
  TimeValidationError,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import moment from "moment";
import React from "react";

type PickerError = DateValidationError | TimeValidationError;

interface Props {
  type?: "date" | "time" | "time24"; // 👈 added "time24"
  name?: string;
  label?: string;
  placeholder?: string;
  value?: any;
  errorText?: string;
  onChange?: (
    value: moment.Moment | null,
    context: PickerChangeHandlerContext<PickerError>
  ) => void;
}

const DatePicker: React.FC<Props> = ({
  type = "date",
  name,
  label,
  value,
  placeholder,
  errorText,
  onChange,
}) => {
  const { palette } = useTheme();

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        {type === "date" && (
          <MobileDatePicker
            sx={{ width: "100%" }}
            value={value ? moment(value) : null}
            format="Do MMM YYYY"
            onChange={onChange}
          />
        )}

        {type === "time" && (
          <MobileTimePicker
            sx={{ width: "100%" }}
            value={value ? moment(value) : null}
            format="hh:mm A" // 12-hour with AM/PM
            onChange={onChange}
          />
        )}

        {type === "time24" && (
          <MobileTimePicker
            sx={{ width: "100%" }}
            value={value ? moment(value) : null}
            format="HH:mm" // 24-hour
            onChange={onChange}
          />
        )}
      </LocalizationProvider>

      {errorText ? (
        <FormHelperText
          sx={{ color: palette.error.main, mt: "3px", mx: "14px" }}
        >
          {errorText}
        </FormHelperText>
      ) : null}
    </>
  );
};

export default DatePicker;
